import React from "react"
import * as all_breadcrumb_components from "../breadcrum-components"

export const getBreadcrumbComponent = ({type, react_key, ...rest}) => {
  const Component = all_breadcrumb_components[type]
  return <Component {...rest} key={react_key}/>
}
